module.exports = __webpack_public_path__ + "img/glida_vanil_no.84131e15.png";